<template>
    <el-dialog
        :visible="showDialog"
        width="100%"
        :fullscreen="true"
        :show-close="false"
        custom-class="custom-dialog"
    >
        <div class="row">
            <div class="col-12">
                <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                    <div>
                        <el-select v-model="format" style="width: 100px;"
                            @change="changeFormat"
                        >
                            <el-option value="a4" label="A4"></el-option>
                            <el-option v-if="ShowTicket80" value="ticket" label="80MM"></el-option>
                            <el-option value="a5" label="A5"></el-option>
                        </el-select>
                    </div>
                    <div>
                        <h3 class="text-danger font-bold">VISTA PREVIA</h3>
                    </div>
                </div>

            </div>
        </div>

        <!-- visualizacion del pdf -->
        <div class="row">
            <div class="col-12" style="min-height: 80vh;">
                <iframe
                    :src="url_pdf"
                    type="application/pdf"
                    width="100%"
                    height="100%"
                ></iframe>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-3 text-left">
                <el-button type="primary" native-type="button" @click="closeDialog">Cerrar</el-button>
            </div>
        </div>

    </el-dialog>
</template>

<script>
import { mapState } from "vuex/dist/vuex.mjs"

export default {
    props: ["showDialog", "preview"],
    data() {
        return {
            format: "a4",
            url_pdf: null,
            urls: [],
        }
    },
    watch: {
        async showDialog() {
            if (this.showDialog) {
                await this.loadPdf()
            }
        },
    },
    computed: {
        ...mapState(["config"]),
        ShowTicket80: function () {
            if (this.config === undefined) return false;
            if (this.config == null) return false;
            if (this.config.show_ticket_80 === undefined) return false;
            if (this.config.show_ticket_80 == null) return false;
            if (
            this.config.show_ticket_80 !== undefined &&
            this.config.show_ticket_80 !== null
            ) {
            return this.config.show_ticket_80;
            }
            return false;
        },
    },

    methods: {
        closeDialog() {
            this.$emit("update:showDialog", false)
            this.url_pdf = null
            this.urls = []
        },
        async loadPdf() {
            this.url_pdf = null
            let exists = this.urls.find((item) => item.format === this.format)
            if (exists) {
                this.url_pdf = exists.URL
            } else {
                this.url_pdf = await this.preview(this.format)
                this.urls = [...this.urls, { format: this.format, URL: this.url_pdf }]
            }
        },
        async changeFormat() {
            await this.loadPdf()
        }
    }
}
</script>

<style>
    .custom-dialog > .el-dialog__header {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/tenant/quotations/partials/preview.vue